import {alias, createModelSchema} from "serializr";
import {BaseObject} from "@/common/BaseObject";
import {Schema} from "@/common/Schema";
import {RedactorUtils} from "@/modules/redactor/core/RedactorUtils";

import {TriggerUtils} from "../trigger/core/TriggerUtils";
import {RewardModel} from "../reward/RewardModel";
import {GuardConfig} from "@/modules/redactor/models/guard/GuardConfig";
import {Difficulty} from "@/modules/redactor/models/utils/Difficulty";


export class DailyQuestOrder extends BaseObject {

    constructor() {
        super();

        this._key = null;
        this._name = null;
        this._group = 0;
        this._difficulty = null;

        this._reward = null;
        this._guard = new GuardConfig();
        this._triggersComplete = [];

        this._chainBack = null;
    }

    get key() {
        return this._key;
    }

    set key(value) {
        this._key = value;
    }

    get name() {
        return this._name;
    }

    set name(value) {
        this._name = value;
    }

    get mapGroup() {
        return this._mapGroup;
    }

    set mapGroup(value) {
        this._mapGroup = value;
    }

    get group() {
        return this._group;
    }

    set group(value) {
        this._group = value;
    }

    get difficulty() {
        return this._difficulty;
    }

    set difficulty(value) {
        this._difficulty = value;
    }

    get reward() {
        return this._reward;
    }

    set reward(value) {
        this._reward = value;
    }

    get guard() {
        return this._guard;
    }

    set guard(value) {
        this._guard = value;
    }

    get triggersComplete() {
        return this._triggersComplete;
    }

    set triggersComplete(value) {
        this._triggersComplete = value;
    }

    get chainBack() {
        return this._chainBack;
    }

    set chainBack(value) {
        this._chainBack = value;
    }

    valid() {

        if (!Number.isInteger(this.group) || this.group < 0) {
            return false;
        }

        if (!this.difficulty || !Difficulty.is(this.difficulty)) {
            return false;
        }

        if (this.reward && !this.reward.valid()) {
            return false;
        }

        if (this.guard && !this.guard.valid()) {
            return false;
        }

        if (this.triggersComplete.some(v => !v || !v.valid())) {
            return false;
        }

        if (this.triggersComplete.length != 1) {
            return false;
        }

        if(this.chainBack){
            if(this.uid === this.chainBack){
                return false;
            }

            const backQuest = RedactorUtils.getDailyQuestOrder(this.chainBack);

            if (!backQuest){
                return false;
            }

            if (backQuest.group != this.group) {
                return false;
            }
            
            if (backQuest.difficulty.id != this.difficulty.id) {
                return false;
            }

            const trigger = this.triggersComplete.at(0);
            const backQuestTrigger = backQuest.triggersComplete.at(0);

            if (backQuestTrigger.kind.id != trigger.kind.id) {
                return false;
            }
        }

        return true;
    }

    copy() {
        let value = super.copy();
        value._enabled = false;
        return value;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new DailyQuestOrder());
        } else if (target instanceof DailyQuestOrder) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(DailyQuestOrder, {
    _key: alias("key", Schema.primitive()),
    _name: alias("name", Schema.primitive()),

    _group: alias("group", Schema.primitive()),
    _difficulty: alias("difficulty", Difficulty.schema()),

    _guard: alias("guard", GuardConfig.schema()),
    _reward: alias("reward", RewardModel.schema()),
    _triggersComplete: alias("triggers_complete", TriggerUtils.schema()),

    _chainBack: alias("chain_back", Schema.primitive()),
});